/* eslint-disable no-sequences */
import classNames from 'classnames';
import * as React from 'react';
import { FormRegisterType } from '../BaseInput';
import styles from './BaseSelect.module.scss';

export interface BaseSelectProps extends React.ComponentProps<'select'> {
	className?: string;
	children: React.ReactNode;
	formRegister?: FormRegisterType;
	disabled?: boolean;
	hasErrors?: boolean;
	onChange: React.ChangeEventHandler<HTMLSelectElement>;
}
export const BaseSelect: React.FC<BaseSelectProps> = ({
	children,
	formRegister,
	className,
	disabled,
	hasErrors,
	...selectProps
}: BaseSelectProps) => {
	return (
		<select
			className={classNames(
				styles.BaseSelect,
				{
					[styles.Select___isInvalid]: hasErrors,
					[styles.Select___disabled]: disabled,
				},
				className,
			)}
			{...formRegister?.register(formRegister.fieldName, formRegister.options)}
			{...selectProps}
		>
			{children}
		</select>
	);
};
